import { Injectable } from '@angular/core';
import { Observable ,  Subject } from 'rxjs';

@Injectable()
export class LoadingService {

    loading = new Subject<boolean>();
    _isLoading: boolean;

    get isLoading() {
        return this._isLoading;
    }

    constructor() { }

    getLoading(): Observable<boolean> {
        return this.loading.asObservable();
    }

    setLoading(state: boolean) {
        this._isLoading = state;
        this.loading.next(state);
    }

}
